import { render, staticRenderFns } from "./EditKanbanfunnel.vue?vue&type=template&id=f59289ec&scoped=true&"
import script from "./EditKanbanfunnel.vue?vue&type=script&lang=js&"
export * from "./EditKanbanfunnel.vue?vue&type=script&lang=js&"
import style0 from "./EditKanbanfunnel.vue?vue&type=style&index=0&id=f59289ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f59289ec",
  null
  
)

export default component.exports